import { AiOutlineMail, AiOutlinePhone } from "react-icons/ai";
import { FaMapMarkerAlt } from "react-icons/fa";
import { v4 as uuidv4 } from "uuid";

const contactData = [
  {
    id: uuidv4(),
    icon: <AiOutlineMail />,
    heading: "Email Address",
    text: "mailto:info@vedanttechnology.com",
    // item1: "info@vedanttechnology.com",
    // item2: "jobs@example.com",
  },

  {
    id: uuidv4(),
    icon: <AiOutlinePhone />,
    heading: "Phone Number",
    text: "tel:+917620108513",
    text2: "tel:+918766080692",
    // item1: "+91 7620108513",
    // item2: " +91 8766080692",
  },

  {
    id: uuidv4(),
    icon: <FaMapMarkerAlt />,
    heading: "Office Address",
    text: "Plot No. K-98, Shop No. 146 & 150, Sanalp Business Center, Waluj MIDC Chh. Sambhainagar, Maharashtra, India",
    // item1:
    //   "Plot No. K-98, Shop No. 146 & 150, Sanalp Business Center, Waluj MIDC Chh. ",
    // item2: "Sambhainagar, Maharashtra, India",
  },
];

export default contactData;
